import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, renderList as _renderList, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e86bff70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "control-wrapper" }
const _hoisted_2 = { class: "panel-button-area" }
const _hoisted_3 = { class: "control-item-detail-row" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "panel-hangup"
}

import { TUICallKitServer } from '../index';
import { onMounted, ref } from 'vue';
import ControlPanelItem from './ControlPanelItem.vue';
import {
  profile,
  callType,
  status,
  remoteList,
  isFromGroup,
  changeRemoteList,
  t,
  dialingInfo,
  cameraList,
  microphoneList,
  currentCamera,
  currentMicrophone,
  currentVideoResolution,
} from '../store';
import { STATUS, CALL_TYPE_STRING } from '../constants';
import RejectSVG from '../icons/reject.vue';
import AcceptAudioSVG from '../icons/acceptAudio.vue';
import AcceptVideoSVG from '../icons/acceptVideo.vue';
import AddSVG from '../icons/add.vue';
import CameraSVG from '../icons/camera.vue';
import MicrophoneSVG from '../icons/microphone.vue';
import SwitchSVG from '../icons/switch.vue';
import HangupSVG from '../icons/hangup.vue';
import MicrophoneClosedBigSVG from '../icons/microphoneClosedBig.vue';
import CameraClosedBigSVG from '../icons/cameraClosedBig.vue';
import { isMobile } from '../utils';
import { VideoResolution } from '../interface';


export default /*#__PURE__*/_defineComponent({
  __name: 'ControlPanel',
  setup(__props) {

const openCameraDetail = ref<boolean>(false);
const openMicrophoneDetail = ref<boolean>(false);

onMounted(() => {
  document.documentElement.addEventListener('click', (e) => {
    openCameraDetail.value = false;
    openMicrophoneDetail.value = false;
  });
});

async function hangup() {
  await TUICallKitServer.hangup();
}

function switchCameraDevice() {
  TUICallKitServer.switchDevice('video', currentCamera.value);
  openCameraDetail.value = false;
}

function switchMicrophoneDevice() {
  TUICallKitServer.switchDevice('audio', currentMicrophone.value);
  openMicrophoneDetail.value = false;
}

async function toggleCamera() {
  if (profile.value?.camera) {
    await TUICallKitServer.closeCamera();
  } else {
    const localDomName = isFromGroup.value ? 'local-group' : 'local-c2c';
    await TUICallKitServer.openCamera(localDomName);
  }
}

async function toggleMicrophone() {
  if (profile.value?.microphone) {
    await TUICallKitServer.closeMicrophone();
  } else {
    await TUICallKitServer.openMicrophone();
  }
}

async function setVideoQuality() {
  await TUICallKitServer.setVideoQuality(currentVideoResolution.value);
}

async function switchCallMediaType() {
  await TUICallKitServer.switchCallMediaType();
}

function addPerson_debug() {
  changeRemoteList([
    ...remoteList.value,
    {
      userID: `qerTest${remoteList.value.length}`,
      isEntered: false,
      microphone: true,
      camera: true,
    },
  ]);
}

function accept() {
  TUICallKitServer.accept();
}

function reject() {
  TUICallKitServer.reject();
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, _toDisplayString(_unref(dialingInfo)), 513), [
      [_vShow, _unref(isMobile) && _unref(status) === _unref(STATUS).DIALING_C2C && _unref(callType) === _unref(CALL_TYPE_STRING).VIDEO]
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_unref(status) === _unref(STATUS).BE_INVITED)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(ControlPanelItem, {
              action: reject,
              isMobile: _unref(isMobile),
              size: _unref(isMobile) ? 'medium' : 'small'
            }, {
              text: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('reject')), 1)
              ]),
              icon: _withCtx(() => [
                _createVNode(RejectSVG)
              ]),
              _: 1
            }, 8, ["isMobile", "size"]),
            _createVNode(ControlPanelItem, {
              action: accept,
              isMobile: _unref(isMobile),
              size: _unref(isMobile) ? 'medium' : 'small'
            }, {
              text: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('accept')), 1)
              ]),
              icon: _withCtx(() => [
                (_unref(callType) === _unref(CALL_TYPE_STRING).AUDIO)
                  ? (_openBlock(), _createBlock(AcceptAudioSVG, { key: 0 }))
                  : (_unref(callType) === _unref(CALL_TYPE_STRING).VIDEO)
                    ? (_openBlock(), _createBlock(AcceptVideoSVG, { key: 1 }))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["isMobile", "size"])
          ], 64))
        : (_unref(status) !== 'idle')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_unref(callType) === _unref(CALL_TYPE_STRING).VIDEO)
                ? (_openBlock(), _createBlock(ControlPanelItem, {
                    key: 0,
                    action: toggleCamera,
                    hasDetail: !_unref(isMobile),
                    isMobile: _unref(isMobile),
                    size: _unref(isMobile) ? 'medium' : 'small'
                  }, {
                    text: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(profile)?.camera ? _unref(t)('camera-opened') : _unref(t)('camera-closed')), 1)
                    ]),
                    icon: _withCtx(() => [
                      (_unref(profile)?.camera)
                        ? (_openBlock(), _createBlock(CameraSVG, { key: 0 }))
                        : _createCommentVNode("", true),
                      (!_unref(profile)?.camera)
                        ? (_openBlock(), _createBlock(CameraClosedBigSVG, { key: 1 }))
                        : _createCommentVNode("", true)
                    ]),
                    detail: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", null, _toDisplayString(_unref(t)('camera')), 1),
                        _createVNode(_component_el_select, {
                          class: "device-select",
                          modelValue: _unref(currentCamera),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentCamera) ? (currentCamera).value = $event : null)),
                          teleported: false,
                          onChange: switchCameraDevice,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(TUICallKitServer).updateCameraList()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: "",
                              label: _unref(cameraList) && _unref(cameraList)[0]?.label,
                              selected: "",
                              disabled: "",
                              hidden: ""
                            }, null, 8, ["label"]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cameraList), (camera) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                value: camera.deviceId,
                                key: camera.deviceId,
                                label: camera.label
                              }, null, 8, ["value", "label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      (_unref(status) === _unref(STATUS).DIALING_C2C)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("div", null, _toDisplayString(_unref(t)('image-resolution')), 1),
                            _createVNode(_component_el_select, {
                              class: "device-select",
                              modelValue: _unref(currentVideoResolution),
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(currentVideoResolution) ? (currentVideoResolution).value = $event : null)),
                              teleported: false,
                              onChange: setVideoQuality
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: "",
                                  label: _unref(t)('default-image-resolution'),
                                  selected: "",
                                  disabled: "",
                                  hidden: ""
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: _unref(VideoResolution).RESOLUTION_480P,
                                  label: "480p",
                                  selected: ""
                                }, null, 8, ["value"]),
                                _createVNode(_component_el_option, {
                                  value: _unref(VideoResolution).RESOLUTION_720P,
                                  label: "720p",
                                  selected: ""
                                }, null, 8, ["value"]),
                                _createVNode(_component_el_option, {
                                  value: _unref(VideoResolution).RESOLUTION_1080P,
                                  label: "1080p",
                                  selected: ""
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["hasDetail", "isMobile", "size"]))
                : _createCommentVNode("", true),
              _createVNode(ControlPanelItem, {
                action: toggleMicrophone,
                hasDetail: !_unref(isMobile),
                isMobile: _unref(isMobile),
                size: _unref(isMobile) ? 'medium' : 'small'
              }, {
                text: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(profile)?.microphone ? _unref(t)('microphone-opened') : _unref(t)('microphone-closed')), 1)
                ]),
                icon: _withCtx(() => [
                  (_unref(profile)?.microphone)
                    ? (_openBlock(), _createBlock(MicrophoneSVG, { key: 0 }))
                    : _createCommentVNode("", true),
                  (!_unref(profile)?.microphone)
                    ? (_openBlock(), _createBlock(MicrophoneClosedBigSVG, { key: 1 }))
                    : _createCommentVNode("", true)
                ]),
                detail: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_unref(t)('microphone')) + " ", 1),
                    _createVNode(_component_el_select, {
                      class: "device-select",
                      modelValue: _unref(currentMicrophone),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(currentMicrophone) ? (currentMicrophone).value = $event : null)),
                      teleported: false,
                      onChange: switchMicrophoneDevice,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(TUICallKitServer).updateMicrophoneList()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: "",
                          label: _unref(microphoneList) && _unref(microphoneList)[0]?.label,
                          selected: "",
                          disabled: "",
                          hidden: ""
                        }, null, 8, ["label"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(microphoneList), (microphone) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            value: microphone.deviceId,
                            key: microphone.deviceId,
                            label: microphone.label
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }, 8, ["hasDetail", "isMobile", "size"]),
              false
                ? (_openBlock(), _createBlock(ControlPanelItem, {
                    key: 1,
                    action: addPerson_debug
                  }, {
                    text: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('invited-person')), 1)
                    ]),
                    icon: _withCtx(() => [
                      _createVNode(AddSVG)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(status) === 'calling-c2c-video')
                ? _withDirectives((_openBlock(), _createBlock(ControlPanelItem, {
                    key: 2,
                    action: switchCallMediaType
                  }, {
                    text: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('video-to-audio')), 1)
                    ]),
                    icon: _withCtx(() => [
                      _createVNode(SwitchSVG)
                    ]),
                    _: 1
                  }, 512)), [
                    [_vShow, !_unref(isMobile)]
                  ])
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(ControlPanelItem, { action: hangup }, {
                text: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(isMobile) ? '' : _unref(t)('hangup')), 1)
                ]),
                icon: _withCtx(() => [
                  _createVNode(HangupSVG)
                ]),
                _: 1
              }, 512), [
                [_vShow, !_unref(isMobile)]
              ])
            ], 64))
          : _createCommentVNode("", true)
    ]),
    (_unref(status) !== _unref(STATUS).IDLE && _unref(status) !== _unref(STATUS).BE_INVITED)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _withDirectives(_createVNode(ControlPanelItem, {
            action: hangup,
            size: _unref(isMobile) ? 'large' : 'small'
          }, {
            text: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(isMobile) ? '' : _unref(t)('hangup')), 1)
            ]),
            icon: _withCtx(() => [
              _createVNode(HangupSVG)
            ]),
            _: 1
          }, 8, ["size"]), [
            [_vShow, _unref(isMobile)]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})